import PhishGuardAI from "./PhishGuardAI";

function App() {
  return <PhishGuardAI />;
}

export default App;

